var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_3174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2.85171e-06H4C1.79 2.85171e-06 0 1.79 0 4V7C0 9.21 1.79 11 4 11H7C9.21 11 11 9.21 11 7V4C11 1.79 9.21 2.85171e-06 7 2.85171e-06ZM20 13H17C14.79 13 13 14.79 13 17V20C13 22.21 14.79 24 17 24H20C22.21 24 24 22.21 24 20V17C24 14.79 22.21 13 20 13ZM13 5C13 3.94 13.44 2.95 14.25 2.22L16.32 0.270003C16.72 -0.109997 17.35 -0.0899972 17.73 0.310003C18.11 0.710003 18.09 1.35 17.69 1.72L15.61 3.67C15.5 3.77 15.41 3.88 15.33 3.99H19C21.21 3.99 23 5.78 23 7.99V9.99C23 10.54 22.55 10.99 22 10.99C21.45 10.99 21 10.54 21 9.99V7.99C21 6.89 20.1 5.99 19 5.99H15.33C15.41 6.1 15.5 6.2 15.6 6.3L17.69 8.26C18.09 8.64 18.11 9.27 17.73 9.67C17.53 9.88 17.27 9.98 17 9.98C16.75 9.98 16.51 9.89 16.31 9.71L14.23 7.76C13.44 7.03 12.99 6.04 12.99 4.99L13 5ZM11 19C11 20.06 10.56 21.04 9.75 21.78L7.68 23.73C7.49 23.91 7.24 24 6.99 24C6.72 24 6.46 23.89 6.26 23.69C5.88 23.29 5.9 22.65 6.3 22.28L8.38 20.33C8.49 20.23 8.58 20.12 8.66 20.01H4.99C2.78 20.01 0.99 18.22 0.99 16.01V14.01C0.99 13.46 1.44 13.01 1.99 13.01C2.54 13.01 2.99 13.46 2.99 14.01V16.01C2.99 17.11 3.89 18.01 4.99 18.01H8.66C8.58 17.9 8.49 17.8 8.39 17.7L6.3 15.74C5.9 15.36 5.88 14.73 6.26 14.33C6.64 13.93 7.27 13.91 7.67 14.29L9.75 16.24C10.54 16.97 10.99 17.96 10.99 19.01L11 19Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_3174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.b26fe8cb9761b0ae0569519c7cec98d8.svg";
export { ForwardRef as ReactComponent };